import { Masthead as EdMasthead } from "~/components/editorial";

/** The Engineers masthead: the period, and when it was pulled. */
export function Masthead({
  periodLabel,
  prevLabel,
  asOf,
}: {
  periodLabel: string;
  prevLabel: string;
  asOf: string;
}) {
  const stamp = new Date(asOf);
  const asOfText = Number.isNaN(stamp.getTime())
    ? ""
    : `${stamp.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} ${stamp.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
  return (
    <EdMasthead
      label="Engineers"
      meta={
        <>
          {periodLabel} vs. {prevLabel}
          {asOfText && ` · as of ${asOfText}`}
        </>
      }
    />
  );
}
